import uploadApi from './UploadApi.js';
import commonApi from './CommonApi.js';

export default {
	sendEmail: async (formData) => {
		return await uploadApi().post('/v1/tools/sendEmail',
				formData, {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'multipart/form-data'
					}
				})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	nepAdminSendEmail: async (formData) => {
		return await uploadApi().post('/v1/tools/nepAdminSendEmail',
				formData, {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'multipart/form-data'
					}
				})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	notificationSendEmail: async (formData) => {
		return await uploadApi().post('/v1/tools/notificationSendEmail',
				formData, {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'multipart/form-data'
					}
				})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	nepAdminSentEmails: async (parameter) => {
		return await commonApi().get('/v1/tools/nepAdminSentEmails', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return [];
				}
			})
			.catch((error) => {
				console.log(error);
				return [];
			});
	},
	groupNotificationSendEmail: async (parameter) => {
		return await commonApi().post('/v1/tools/groupNotificationSendEmail', parameter)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	processNotificationSendEmail: async (formData) => {
		return await commonApi().post('/v1/tools/processNotificationSendEmail',
			formData, {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'multipart/form-data'
				}
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
}